import { render, staticRenderFns } from "./MainDropdown.vue?vue&type=template&id=10bc2f50&"
import script from "./MainDropdown.vue?vue&type=script&lang=js&"
export * from "./MainDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports